module.exports = __webpack_public_path__ + "static/img/img-final-research.e5863b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-final-research.png
// module id = j4+U
// module chunks = 1